"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_009_MESSAGE_FEEDBACK = void 0;
/**
 * Migration 009 (server only): per-message thumbs-up/down feedback.
 *
 * Records a single rating per (tenant, message, user) tuple. The UNIQUE
 * constraint lets callers upsert — submitting a new rating replaces the old
 * one without a separate SELECT.
 *
 * `rating` is 1 (like) or -1 (dislike). `comment` is an optional free-text
 * annotation attached alongside the rating.
 */
const MIGRATION_009_SQL = `\
CREATE TABLE IF NOT EXISTS omni_message_feedback (
  id         TEXT PRIMARY KEY,
  tenant_id  TEXT NOT NULL REFERENCES omni_tenants(id),
  message_id TEXT NOT NULL REFERENCES omni_messages(id) ON DELETE CASCADE,
  user_id    TEXT NOT NULL,
  rating     INTEGER NOT NULL CHECK (rating IN (1, -1)),
  comment    TEXT,
  created_at BIGINT NOT NULL,
  UNIQUE (tenant_id, message_id, user_id)
);
CREATE INDEX IF NOT EXISTS idx_omni_message_feedback_message
  ON omni_message_feedback(tenant_id, message_id);
`;
exports.MIGRATION_009_MESSAGE_FEEDBACK = {
    id: '009_message_feedback',
    version: 9,
    name: 'per-message thumbs feedback',
    side: 'server',
    sql: MIGRATION_009_SQL,
};
//# sourceMappingURL=009_message_feedback.js.map